import React, { useEffect, useState, useRef } from 'react';
import { get, isArray } from 'lodash';
import { useSelector } from 'react-redux';
import { getIcon } from '../../../helpers/icons';
import { useLocation } from "react-router-dom";

import Logo from "./Logo";
import SubMenu from './SubMenu';
import MegaMenu from './MegaMenu';
import MobileMenu from "./MobileMenu";
import FilterHeader from './FilterHeader';
import Link from "../../../components/Link";
import Spinner from '../../../components/Spinner';
import AsyncGet from "../../../components/AsyncGet";
import Button from "../../../components/Field/Button";
import ProfilePhoto from '../../../components/ProfilePhoto';

import style from './style.module.css';

export default function Header({ context }) {
    const { winHeight } = context || {};
    const userData = useSelector((state) => state.storage.data);
    const location = useLocation();
    const { pathname } = location;

    const headerRef = useRef(null);

    const [activeId, setActiveId] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const handleClick = (activeId) => {
        setActiveId((prevId) => (prevId === activeId ? null : activeId));
    };

    useEffect(() => {
        const segments = pathname.split("/").filter(Boolean);
        let currentPageName = segments[segments.length - 1] || 'home';
        if (pathname.includes("/reset-password/")) {
            currentPageName = "reset-password";
        }

        if (pathname.includes("/setup-password/")) {
            currentPageName = "setup-password";
        }

        if (pathname.includes("/article/")) {
            currentPageName = "single-article";
        }

        if (pathname.includes("/book/")) {
            currentPageName = "single-book";
        }

        if (pathname.includes("/tag/") || pathname.includes("/theme/") || pathname.includes("/category/") || pathname.includes("/series/")) {
            currentPageName = "single-category";
        }

        const htmlElement = document.documentElement;
        htmlElement.id = currentPageName;

        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                htmlElement.classList.add("pageScrolled");
            } else {
                htmlElement.classList.remove("pageScrolled");
            }
        });
    }, [pathname]);

    useEffect(() => {
        const htmlElement = document.documentElement;
        if (activeId !== null) {
            htmlElement.classList.add("megaMenuIsActive");
        } else {
            htmlElement.classList.remove("megaMenuIsActive");
        }
    }, [activeId]);

    useEffect(() => {
        const htmlElement = document.documentElement;
        if (isMenuOpen) {
            htmlElement.classList.add("mobileMenuIsActive");
        } else {
            htmlElement.classList.remove("mobileMenuIsActive");
        }

        if (isFilterOpen) {
            htmlElement.classList.add("searchFilterIsActive");
        } else {
            htmlElement.classList.remove("searchFilterIsActive");
        }
    }, [isMenuOpen, isFilterOpen]);

    useEffect(() => {
        if (pathname) {
            setIsMenuOpen(false)
        }
    }, [pathname]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (headerRef.current && !headerRef.current.contains(event.target)) {
                setActiveId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const SearchBtn = () => {
        return (
            <Link onClick={() => { setIsFilterOpen(isFilterOpen => !isFilterOpen) }} className={`${style.search} ${style.secondaryMenuItem}`}>
                <i className={`${getIcon("Search")}`}></i>
            </Link>
        );
    }

    return (
        <>
            <header className={`${style.header} ${get(userData, "id", undefined) === undefined ? style.loginNo : style.loginYes}`}>
                <div ref={headerRef} className={style.headerWrapper}>
                    <div className={style.c}>
                        <div className={style.headerRow}>
                            <div onClick={() => { setIsMenuOpen(isMenuOpen => !isMenuOpen); setIsFilterOpen(false) }} className={`${style.mobileBar} ${isMenuOpen ? style.mobileMenuOpen : ''}`}>
                                <div className={style.bar}></div>
                            </div>
                            <Logo />
                            <div className={style.mainMenu}>
                                <AsyncGet
                                    url="/header"
                                    permissionText={false}
                                    loadOnMount={true}
                                    render={({ data, fetching, loaded }) => {
                                        if (isArray(data.links) && data.links.length > 0 && loaded === true && fetching === false) {
                                            return (
                                                <div className={style.mainMenuRow}>
                                                    {
                                                        data.links.map((item, index) => {
                                                            if ((item.menu_type === "mega_menu" || item.menu_type === "sub_menu") && (item.show_in_public === "1" || get(userData, "id") !== undefined)) {
                                                                let megaMenuId = "megaMenuColumn_" + index;
                                                                return (
                                                                    <div 
                                                                        key={`mainMenuMega_${index}_${item.label}`} 
                                                                        className={`${style.mainMenuItem}`}
                                                                        onMouseEnter={() => {
                                                                            handleClick(megaMenuId)
                                                                            setIsFilterOpen(false)
                                                                        }}
                                                                        onMouseLeave={() => {
                                                                            handleClick(megaMenuId)
                                                                        }}
                                                                    >
                                                                        <Link
                                                                            className={`${style.mainMenuItemLink} ${activeId === megaMenuId ? style.menuActive : ''}`}
                                                                            key={`mainMenuItem_${index}`}
                                                                            to={item.url}
                                                                        >
                                                                            {item.label}
                                                                        </Link>
                                                                        {
                                                                            item.menu_type === "mega_menu" && item.mega_menu.length > 0 && (
                                                                                <MegaMenu
                                                                                    megaMenu={item}
                                                                                    activeId={activeId}
                                                                                    resetActive={() => setActiveId(null)}
                                                                                    megaMenuId={megaMenuId}
                                                                                />
                                                                            )
                                                                        }
                                                                        {
                                                                            item.menu_type === "sub_menu" && item.sub_menu.length > 0 && (
                                                                                <SubMenu
                                                                                    subMenu={item.sub_menu}
                                                                                    activeId={activeId}
                                                                                    resetActive={() => setActiveId(null)}
                                                                                    megaMenuId={megaMenuId}
                                                                                />
                                                                            )
                                                                        }
                                                                    </div>
                                                                )
                                                            }
                                                            else {
                                                                if (item.show_in_public === "1" || get(userData, "id") !== undefined) {
                                                                    return (
                                                                        <div key={`mainMenuLink_${index}_${item.label}`} className={`${style.mainMenuItem}`}>
                                                                            <Link
                                                                                onClick={() => {
                                                                                    setActiveId(null)
                                                                                    setIsFilterOpen(false)
                                                                                }}
                                                                                className={style.mainMenuItemLink}
                                                                                to={item.url}
                                                                            >
                                                                                {item.label}
                                                                            </Link>
                                                                        </div>
                                                                    )
                                                                }
                                                                else {
                                                                    return null
                                                                }
                                                            }
                                                        })
                                                    }
                                                </div>
                                            )
                                        }
                                        else {
                                            return (
                                                <div className={style.mainMenuRow}>
                                                    <Spinner />
                                                </div>
                                            )
                                        }
                                    }}
                                />
                            </div>
                            <div className={style.secondaryMenu}>
                                <div className={style.secondaryMenuRow}>
                                    <SearchBtn />
                                    <ProfilePhoto />
                                    {
                                        get(userData, "id", false) === false && (
                                            <>
                                                <div className={`${style.loginBtn} ${style.loginBtna}`}>
                                                    <Link
                                                        onClick={() => setActiveId(null)}
                                                        to="/sign-in"
                                                    >
                                                    Sign In
                                                    </Link>
                                                </div>
                                                <div className={style.loginBtn}>
                                                    <Button
                                                        onClick={() => setActiveId(null)}
                                                        color="buttonPrimary"
                                                        link="/register"
                                                        label="Sign Up"
                                                    />
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <MobileMenu status={isMenuOpen} />
            </header>
            <FilterHeader status={isFilterOpen} setFilter={setIsFilterOpen} winHeight={winHeight} />
        </>
    )
}